// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-logo {
  margin-left: 15px;
  max-height: 25px;
}

.pb-toolbar {
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);
}

.menu-toolbar {
  width: 100%;
}
.menu-toolbar ul {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.menu-toolbar ul li {
  background: none;
  display: inline-block;
  text-decoration: none;
  margin-left: 15px;
}
.menu-toolbar ul li > button {
  display: flex;
  align-items: center;
  align-content: center;
  background: none;
}
.menu-toolbar ul li > button.profile-button > img {
  border-radius: 50%;
  height: 30px;
  width: 30px;
  max-width: none;
  margin-right: 10px;
}
.menu-toolbar ul li > button.profile-button > span {
  font-size: 16px;
}
.menu-toolbar ul li > button.active {
  color: var(--ion-color-danger);
}
.menu-toolbar ul li > button.active span {
  font-size: 12px;
}

#main-content {
  margin-top: 74px;
  padding: 10px 40px;
}

@media only screen and (max-width: 700px) {
  .profile-button span {
    display: none;
  }
  .profile-button img {
    margin-right: 0px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/layout/layout.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,+GAAA;EAGA,oHAAA;EAGA,uHAAA;AAHF;;AAQA;EACE,WAAA;AALF;AAOE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AALJ;AAMI;EACE,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;AAJN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AAHR;AAKU;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAHZ;AAKU;EACE,eAAA;AAHZ;AAMQ;EACE,8BAAA;AAJV;AAKU;EACE,eAAA;AAHZ;;AAWA;EACE,gBAAA;EACA,kBAAA;AARF;;AAWA;EAEI;IACE,aAAA;EATJ;EAWE;IACE,4BAAA;EATJ;AACF","sourcesContent":[".menu-logo {\n  margin-left: 15px;\n  max-height: 25px;\n}\n\n.pb-toolbar {\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14),\n  0 2px 1px -1px rgba(0, 0, 0, 0.12),\n  0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14),\n  0 2px 1px -1px rgba(0, 0, 0, 0.12),\n  0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14),\n  0 2px 1px -1px rgba(0, 0, 0, 0.12),\n  0 1px 3px 0 rgba(0, 0, 0, 0.2);\n}\n\n.menu-toolbar {\n  width: 100%;\n\n  ul {\n    margin: 0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    li {\n      background: none;\n      display: inline-block;\n      text-decoration: none;\n      margin-left: 15px;\n      & > button {\n        display: flex;\n        align-items: center;\n        align-content: center;\n        background: none;\n        &.profile-button {\n          & > img {\n            border-radius: 50%;\n            height: 30px;\n            width: 30px;\n            max-width: none;\n            margin-right: 10px;\n          }\n          &>span {\n            font-size: 16px;\n          }\n        }\n        &.active {\n          color: var(--ion-color-danger);\n          span {\n            font-size: 12px;\n          }\n        }\n      }\n    }\n  }\n}\n\n#main-content {\n  margin-top: 74px;\n  padding: 10px 40px;\n}\n\n@media only screen and (max-width: 700px) {\n  .profile-button{\n    span{\n      display: none;\n    }\n    img{\n      margin-right: 0px !important;\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
